import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const Legendary = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - LEGENDARY</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - LEGENDARY</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Intro: Muhfaad]<br/>
                Abhi maine kal hi ek talent dekha<br/>
                Ek artish hai Gaush<br/>
                Everybody will be listening to him<br/>
                Like as a rapper I'm saying<br/>
                Accha grow karega wo dekhna<br/>
                Boht potential hai bande me, boht potential hai<br/>
                <br/>
                [Verse]<br/>
                Kid inspired by Dilin Nair, Bilal Shaikh, Gaurav Pal<br/>
                My mind state onto mars<br/>
                Wo jantey kaun hai God<br/>
                When I diss a peer, I go wild<br/>
                Treat 'em like Raftaar's comment, you'd disappear in a while<br/>
                Man I'm a (Gemini)Gem when I spit, the world goes (Virgo) into it<br/>
                Spread like Cancer in these areas (Aries), got tourists (Taurus) visiting<br/>
                Liberal (Libra) soch, haa bolo Kaaprahe Kaun (Capricorn)<br/>
                Focus on my goals<br/>
                Sack a terrorist (Sagittarius) the way I blow up on my own<br/>
                Like suicid&#1077; bombers, acquire areas (Aquarius)<br/>
                L&#1077;ave it messy like I'm Leo (Lionel Messi) lage mass hysteria<br/>
                Na hopaye system (Pisces) change, stings like Scorpions (Scorpio) I don't react<br/>
                Get the signs, I'm 'bout to make a killing - Zodiac<br/>
                Train karke bhi track pe na aaye, ye megablocks<br/>
                I'm 6'4, your peaks to me look like Leprachauns<br/>
                Falling like dominoes (Domino's) this shit is like Garlic, buy the dip when you get the bread jaise kare
                invest in stocks<br/>
                Gire Gire Gire<br/>
                Upar se bohot neeche / neech ye<br/>
                Akal inhe kam / income, par NET pe kare GROSS cheeze<br/>
                Fukre Dope, Asthmatic, nai fook rahe dope<br/>
                Par Joints mere Blunt kaafi, haa mai kardu inhe smoke Seedhe<br/>
                Maut logo ko, swing right at your head dawg<br/>
                Sir dhadh se alag like Muhfaad in a Face-Off<br/>
                Aim kabhi nahi chook ti<br/>
                Mask on, tune dekha mera asli roop nahi<br/>
                First single hit right off the bat<br/>
                Field me delivery fast, Mike Holding / Mic Hold and blast<br/>
                I might go braaa, no dismissal left<br/>
                Run up to the mic it's sounding like I'm whispering death<br/>
                Should I do it simple, samajhne me doori inko<br/>
                Ye bars inke sar ke upar like all of them doing limbo<br/>
                Spiritually peace du inko, lyrically pees du inko<br/>
                I got the game in my hand like a console, playing Nintendo<br/>
                Ye hai Hip-Hop for real<br/>
                Brown Munde, we do it like Chris, Rock at Will<br/>
                Smith and Wesson shit, mere clips show kare caliber<br/>
                Got Loaded Weapons, like AP Dhillon / Dilo te kare magic hum<br/>
                Dub it cuz we having fun<br/>
                Shoot it like we grabbing guns<br/>
                Drop it like it's hot in summer<br/>
                Hit ho like a pack of blunts<br/>
                Chaiye underground, to le kabar khodi<br/>
                NM represent, mache khauf jab ye Kalam boli (Kalamboli)<br/>
                Inki bas ki naa ki rok sake<br/>
                Tha mai antisocial, kar raha gigs ab antisocial me<br/>
                DJ's se leke academics tak call me the fucking best<br/>
                Everyday struggle, mile maut ho joe budden press/ jo button press<br/>
                Khada top pe, jo aate bhidne girte khai me<br/>
                Peethpeeche bhauk ke saamne karte milke bhai ye<br/>
                Na kare halko se work out, no lifting light weights<br/>
                Fly but third class, rakh nai paate business private
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default Legendary;
